export const SPONSORED_AD_TRANSLATION_NAMESPACE = "sponsoredAd";

export const SPONSORED_AD_TABLE_MENU_TK = "SPONSORED_AD_TABLE_MENU_TK";
